import { DatePipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PropertyType } from 'src/app/models/enums/property-type';
import { AvmLinkPipe } from '../../pipes/avm-link.pipe';
import { ColumnDefinition } from '../models/column-definition';
import { ColumnType } from '../models/column-type';

@Component({
    selector: 'app-table-cell',
    templateUrl: './table-cell.component.html',
    styleUrls: ['./table-cell.component.scss'],
    imports: [NgClass, MatButtonModule, MatIconModule, DatePipe, AvmLinkPipe]
})
export class TableCellComponent {
    /** Déclaration des ENUM */
    public ColumnType = ColumnType;
    public PropertyType = PropertyType;

    @Input()
    public column: ColumnDefinition;

    /** Instance du dossier affiché sur cette ligne. */
    @Input()
    row;

    public isDeveloped: boolean = false;

    constructor() {}

    public toggleDevelop() {
        this.isDeveloped = !this.isDeveloped;
    }
}
